import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
type AlternatePickHeaderBandProps = {
  label: string;
};
export default function AlternatePickHeaderBand(t0) {
  const $ = _c(2);
  const {
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <Box sx={_temp} boxShadow="0 4px 8px 0 rgba(100,102,106,0.1), 0 1px 4px 0 rgba(100,102,106,0.36)" position="relative" paddingY={2} paddingX={3} textAlign="center" height="auto" color="white" bgcolor="primary.main"><Typography color="white" variant="accent" fontSize="0.75rem" letterSpacing="0.09rem" lineHeight="1.1">Alternate Pick: {label}</Typography></Box>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(t0) {
  const {
    palette
  } = t0;
  return {
    marginTop: "0.5rem",
    left: "-2.25rem",
    marginBottom: {
      xs: 3,
      sm: 4,
      md: 3
    },
    "::before": {
      borderColor: `transparent ${palette.primary.dark} transparent transparent`,
      borderStyle: "solid",
      borderWidth: "0 0.5rem 0.5rem 0",
      content: "\"\"",
      height: 0,
      left: 0,
      position: "absolute",
      top: "100%",
      width: 0
    }
  };
}